import React from 'react';
import { useState, useEffect } from 'react';
import profilePhoto from '../assets/img/profilePhoto.png';
import ProfileMyApp from '../components/ui/ProfileMyApp';
import TailwindInput from '../components/ui/TailwindInput';
import { useCountries } from "use-react-countries";
import {
  Select,
  Option
} from "@material-tailwind/react";
import rewrite from '../assets/img/rewrite.svg';
import PrimaryButton from '../components/ui/PrimaryButton';
import createAction from '../components/operational/createAction';
import { useNavigate } from "react-router-dom";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { Dropdown } from 'primereact/dropdown';
import PhoneInput from 'react-phone-input-2';
import SecondaryButton from '../components/ui/SecondaryButton';
import { useSelector } from 'react-redux';
import CreateAction from '../components/operational/createAction';
import { translate } from '../utils/language';
import { useDispatch } from 'react-redux';
import myUserSlice from '../redux/myUserSlice';


const Profile = ({ setIsOpen, setIsPasswordRecoveryModalOpen }) => {
  const navigate = useNavigate();
  const [profileData, setProfileData] = useState({});
  const profile = useSelector(state => state.myUserSlice.user)
  const [isError, setIsError] = useState([])
  const dispatch = useDispatch()
  useEffect(() => {
    setProfileData(profile)
  }, [])


  const languages = [
    { name: 'Türkçe', code: 'Turkish' },
  ]
  const [selectedLanguage, setSelectedLanguage] = useState(languages[0]);

  const updateProfileData = (key, value) => {
    setProfileData(state => ({ ...state, [key]: value }))
  }


  const errorGenerator = newError => {
    setIsError(state => {
      const newState = [...state];
      newState.push(newError);
      return newState;
    });
    return true;
  };

  const errorChecker = conditions => {
    setIsError([]);
    const failedCondition = conditions.filter(condition => {
      const check = condition.check;
      if (check) return errorGenerator(condition.error);
    });
    if (failedCondition.length > 0) return true;
  };


  const profileUpdateConditions = [
    {
      check: !profileData.name,
      error: 'missingName',
    },
    {
      check: !profileData.surname,
      error: 'missingSurname',
    },
    {
      check: !/^905\d{2}[\s\-]?\d{3}[\s\-]?\d{2}[\s\-]?\d{2}$/.test(profileData.phone),
      error: 'missingPhone',
    },
  ]

  const updateProfile = async () => {

    const isErrorChecker = errorChecker(profileUpdateConditions);
    if (isErrorChecker) return;
    try {
      const response = await CreateAction({
        method: 'patch',
        path: '/profile',
        data: { name: profileData.name, surname: profileData.surname, phone: profileData.phone },
        showPreLoader: true,
        isFileUploading: false,
      });
      if (response?.error) return

      const user = response?.result?.resultData;
      dispatch(myUserSlice.actions.setUser(user));
      setIsOpen(false)
    } catch (error) {
    }
  };

  useEffect(() => {
    setIsError([])
  }, [profileData])
  return (
    <div className=''>
      <div className=' flex items-center justify-center min-w-full'>
        <div className='bg-white relative rounded-[10px] '>
          <div className='flex flex-col-reverse gap-[20px] lg:gap-0 lg:flex-row'>
            <div className=' w-[100%]'>
              <div className='flex flex-row justify-between'>

                <span className="text-[#5E5873] font-medium text-[18px] mb-[20px] block">
                  Profil Bilgilerim
                </span>
                <div className=''>
                  {!profile?.isSocialLogin &&

                    <button className='flex items-center gap-[10px] text-[#5E5873]'
                      onClick={() => {

                        setIsPasswordRecoveryModalOpen(true)
                      }
                      }>
                      <span>Şifreyi Değiştir</span>
                      <img src={rewrite} />
                    </button>}
                </div>
              </div>

              <div className='grid mt-[40px] grid-cols-1 gap-[20px] lg:grid-cols-2'>
                <TailwindInput isError={isError.includes('missingName')} errorMessage={translate('missingName')} onChange={(e) => { updateProfileData("name", e.target.value) }} label={"Adınız"} classes={""} value={profileData.name} />
                <TailwindInput isError={isError.includes('missingSurname')} errorMessage={translate('missingSurname')} onChange={(e) => { updateProfileData("surname", e.target.value) }} label={"Soyadınız"} classes={""} value={profileData.surname} />
                <TailwindInput isDisabled={true} value={profileData.email} label={"E-Posta"} classes={"text-[#5E5873]"} />
                <div className='h-5'>

                  <PhoneInput
                    preferredCountries={['tr', 'de']}
                    inputStyle={{
                      width: '100%',
                      borderWidth: '2px',
                      borderColor: isError.includes("missingPhone") ? '#f56565' : '#e5e7eb',
                      height: '2.5rem',
                      borderRadius: '0.5rem',
                      paddingLeft: '3.5rem',
                    }}
                    inputClass="border-red-500"
                    buttonStyle={{ width: '45px', background: 'white', borderColor: isError.includes("missingPhone") ? '#f56565' : '#e5e7eb', borderWidth: "2px" }}
                    buttonClass=""
                    searchClass=""
                    dropdownClass=""
                    country={'tr'}
                    value={profileData.phone}
                    onChange={phone => updateProfileData("phone", phone)}
                  />
                </div>
                <Dropdown value={selectedLanguage} onChange={(e) => setSelectedLanguage(e.value)}
                  options={languages} optionLabel="name"
                  className="w-full h-[45px]" />



              </div>
              <div className='grid mt-[20px] grid-cols-1 gap-[20px] lg:grid-cols-2'>
                <SecondaryButton value={"Kapat"} onClick={() => (setIsOpen(false))} />

                <PrimaryButton onClick={() => updateProfile()} classes={"w-[100%]"} value={"Bilgilerimi Güncelle"} />

              </div>


            </div>

          </div>

        </div>
      </div>
    </div>
  )
}
const passwordChecks = [
  { text: "En az bir büyük harf (A-Z)", check: "missingUppercase" },
  { text: "En az 1 sayı (0-9)", check: "missingNumber" },
  { text: "En az 8 karakter", check: "missingLength" },
  { text: "En az 1 özel karakter", check: "missingSpecialChar" }


]
export const ChangePassword = ({ setIsOpen }) => {
  const navigate = useNavigate();
  const [passwordConfirmation, setPasswordConfirmation] = useState("")
  const [password, setPassword] = useState("")
  const [oldPassword, setOldPassword] = useState("")
  const [isError, setIsError] = useState([])
  const dispatch = useDispatch()
  const passwordCheckConditions = [
    {
      check: !/[A-Z]/.test(password), // Checks for at least one uppercase letter
      error: "missingUppercase"
    },
    {
      check: !/[0-9]/.test(password), // Checks for at least one numeric digit
      error: "missingNumber"
    },
    {
      check: !/^.{8,}$/.test(password), // Checks for a minimum length of 8 characters
      error: "missingLength"
    },
    {
      check: !/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password), // En az bir özel karakter içeriyor mu?
      error: "missingSpecialChar"
    }
  ];
  const createConditions = [
    {
      check: !/^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&()_+={}[\]:;<>,.?/~]).{8,}$/.test(password),
      error: 'weakPassword',
    },
    {
      check: passwordConfirmation !== password,
      error: 'unmatchedPassword',
    }
  ];

  const errorGenerator = newError => {
    setIsError(state => {
      const newState = [...state];
      newState.push(newError);
      return newState;
    });
    return true;
  };
  const errorChecker = conditions => {
    setIsError([]);
    const failedCondition = conditions.filter(condition => {
      const check = condition.check;
      if (check) return errorGenerator(condition.error);
    });
    if (failedCondition.length > 0) return true;
  };
  useEffect(() => {
    errorChecker(passwordCheckConditions)
  }, [password, oldPassword, passwordConfirmation])
  console.log(isError)
  const updatePassword = async () => {
    const isErrorChecker = errorChecker([...createConditions, ...passwordCheckConditions]);
    if (isErrorChecker) return;
    try {
      const response = await CreateAction({
        method: 'post',
        path: '/sso/changePassword',
        data: { oldPassword, password },
        showPreLoader: true,
        isFileUploading: false,
      });
      if (response?.error) return

      setIsOpen(false)
    } catch (error) {
      ;
    }
  }
  return (
    <div className=''>
      <div className=' flex items-center justify-center min-w-full'>
        <div className='bg-white relative rounded-[10px] '>
          <div className='flex flex-col gap-[20px]'>
            <div className='flex flex-row justify-between'>

              <span className="text-[#5E5873] font-medium text-[18px] mb-[20px] block">
                Şifrenizi Değiştirin
              </span>

            </div>
            <div className='flex flex-row gap-[40px]'>
              <div className='flex flex-col gap-[20px]'>
                <TailwindInput type="password" onChange={(e) => setOldPassword(e.target.value)} value={oldPassword} label={"Eski Şifre"} classes={""} />
                <TailwindInput isError={isError?.includes("weakPassword")} errorMessage={translate("weakPassword")} type="password" onChange={(e) => setPassword(e.target.value)} value={password} label={"Yeni Şifre"} classes={""} />
                <TailwindInput isError={isError?.includes("unmatchedPassword")} errorMessage={translate("unmatchedPassword")} type="password" onChange={(e) => setPasswordConfirmation(e.target.value)} value={passwordConfirmation} label={"Yeni Şifreyi Onayla"} classes={""} />
                <p className='text-[10px] text-gray-500'>En az 8 karakterden oluşan, büyük harf, küçük harf, rakam ve özel karakter içeren güçlü bir şifre belirleyin.</p>
                <div className='grid mt-[20px] grid-cols-1 gap-[20px] lg:grid-cols-2'>
                  <SecondaryButton value={"goBack"} onClick={() => (setIsOpen(false))} />

                  <PrimaryButton onClick={() => updatePassword()} classes={"w-[100%]"} value={"Şİfremi Güncelle"} />

                </div>
              </div>
              <div className='flex flex-col gap-[20px] w-[200px] shrink-0'>
                <span className="text-[#5E5873] font-medium text-[16px] block">
                  Parola şunları içermelidir:
                </span>
                <div className='flex flex-col gap-[10px]'>
                  {passwordChecks.map((passwordCheck) => {
                    return <div className={`${!isError.includes(passwordCheck.check) ? "text-green-500 line-through" : "text-gray-300"} text-[12px] font-semibold`}> {passwordCheck.text} </div>
                  })}
                </div>
              </div>

            </div>



          </div>

        </div>
      </div>
    </div>
  )
}

export const ProfileModal = ({ setIsOpen }) => {
  const [isPasswordRecoveryModalOpen, setIsPasswordRecoveryModalOpen] = useState(false)
  return (
    <>
      <div className={`appear fixed inset-0 overflow-y-visible flex flex-col p-5 items-center top-0 left-0 z-[100]`}>
        <div className='shadow' ></div>
        <div className="bg-white p-8 w-[90%] md:w-[60%] xl:w-[600px] z-[500] overflow-visible h-auto m-auto rounded-2xl">

          <Profile setIsPasswordRecoveryModalOpen={setIsPasswordRecoveryModalOpen} setIsOpen={setIsOpen} />
        </div>
      </div>
      {isPasswordRecoveryModalOpen &&
        <div className={`appear fixed inset-0 overflow-y-visible flex flex-col p-5 items-center top-0 left-0 z-[100]`}>
          <div className='shadow' ></div>
          <div className="bg-white p-8 w-[90%] md:w-[60%] xl:w-[700px] z-[500] overflow-visible h-auto m-auto rounded-2xl">

            <ChangePassword setIsOpen={setIsPasswordRecoveryModalOpen} />
          </div>
        </div>
      }
    </>
  )
}
export default Profile
